import service from '@/utils/server';

const modName = '/md/route/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

//编辑详情
export const detailInfo = data => {
  return service({
    url: modName + 'routeEdit/' + data.routeId,
    method: 'post',
    data
  });
};
//编辑提交
export const editSubmit = data => {
  return service({
    url: modName + 'submit',
    method: 'post',
    data
  });
};
//批量删除
export const deleteBatch = data => {
  return service({
    url: modName + 'deleteBatch',
    method: 'post',
    data
  });
};
//导出
export const exportData = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};
//导入
export const upload = data => {
  let config = {
    timeout: 500000,
    headers: {
      "Content-Type": "multipart/form-data"
    },
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'uploadRoute',
    method: 'post',
    data
  });
};
//模板下载
export const downLoadTemplate = data => {
  let config = {
    timeout: 500000,
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'template/' + data.templateName,
    method: 'post',
    data
  });
};



// WEBPACK FOOTER //
// ./src/page/md/route/api/index.js